import MultiMetricCard from './MultiMetricCard'
import React from 'react'

export default function ActionItems({ billable, loading }) {
  const totalActiveIssues = (billable?.stat_new_tickets || 0) + (billable?.stat_open_tickets || 0)
  const totalInvoiceIssues = (billable?.stat_overdue_invoices || 0) + (billable?.stat_error_invoices || 0)
  const attesteringCount = billable?.stat_attestering_invoices || 0

  const metrics = [
    {
      icon: 'fa-wrench',
      color: totalActiveIssues > 5 ? 'text-danger' : totalActiveIssues > 2 ? 'text-warning' : 'text-success',
      value: totalActiveIssues,
      label: 'Öppna ärenden'
    },
    {
      icon: 'fa-file-invoice-dollar',
      color: totalInvoiceIssues > 3 ? 'text-danger' : totalInvoiceIssues > 0 ? 'text-warning' : 'text-success',
      value: totalInvoiceIssues,
      label: 'Hyresavier att hantera'
    },
    {
      icon: 'fa-file-invoice-dollar',
      color: attesteringCount > 0 ? 'text-warning' : 'text-success',
      value: attesteringCount,
      label: 'Attestering'
    },
    {
      icon: 'fa-calendar-times',
      color: billable?.stat_ends_month > 2 ? 'text-warning' : 'text-info',
      value: billable?.stat_ends_month || 0,
      label: 'Uthyrningar avslutas'
    }
  ]
  return (

    <MultiMetricCard
      title="Saker att hantera"
      icon="fa fa-tasks"
      metrics={metrics}
      loading={!billable?.id}
    />
  )
}
